import './App.css';
import BikeCalculator from './BikeCalculator';

function App() {
  return (
    <div className="App">
      <BikeCalculator />
    </div>
  );
}

export default App;
